import { render, staticRenderFns } from "./cart-table.vue?vue&type=template&id=6ff9e34a&scoped=true&"
import script from "./cart-table.vue?vue&type=script&lang=js&"
export * from "./cart-table.vue?vue&type=script&lang=js&"
import style0 from "./cart-table.vue?vue&type=style&index=0&id=6ff9e34a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff9e34a",
  null
  
)

export default component.exports